import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Select, MenuItem, FormControl, InputLabel, Button as MuiButton, Grid, IconButton
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';

const AddParticipantModal = ({ open, onClose, onSaved, sides, onAddSide, onDeleteSide, participant }) => {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    side: sides[0] || 'bride',
    status: 'invited',
    notes: ''
  });
  const [newSide, setNewSide] = useState('');
  const [sideDialogOpen, setSideDialogOpen] = useState(false);
  const [sideToDelete, setSideToDelete] = useState('');
  const [deleteSideDialogOpen, setDeleteSideDialogOpen] = useState(false);

  React.useEffect(() => {
    if (participant) {
      setForm(participant);
    } else {
      setForm({ name: '', phone: '', email: '', side: sides[0] || 'bride', status: 'invited', notes: '' });
    }
  }, [participant, sides, open]);

  const handleFormChange = (key, value) => setForm(f => ({ ...f, [key]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Katılımcı ekleme işlemi parent'tan props ile gelmeli, burada onSaved çağrılır
    await onSaved(form);
    setForm({ name: '', phone: '', email: '', side: sides[0] || 'bride', status: 'invited', notes: '' });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{participant ? 'Katılımcı Düzenle' : 'Yeni Katılımcı'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="İsim"
                value={form.name}
                onChange={e => handleFormChange('name', e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Telefon"
                value={form.phone}
                onChange={e => handleFormChange('phone', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="E-posta"
                type="email"
                value={form.email}
                onChange={e => handleFormChange('email', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Taraf</InputLabel>
                <Select
                  value={form.side}
                  onChange={e => handleFormChange('side', e.target.value)}
                  label="Taraf"
                  endAdornment={
                    <>
                      <IconButton size="small" sx={{ mr: 1 }} onClick={() => setSideDialogOpen(true)}>
                        <AddIcon />
                      </IconButton>
                      <IconButton size="small" sx={{ mr: 2 }} onClick={() => { setSideToDelete(form.side); setDeleteSideDialogOpen(true); }}>
                        <DeleteIcon />
                      </IconButton>
                    </>
                  }
                >
                  {sides.map(side => (
                    <MenuItem key={side} value={side}>{side}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Durum</InputLabel>
                <Select
                  value={form.status}
                  onChange={e => handleFormChange('status', e.target.value)}
                  label="Durum"
                >
                  <MenuItem value="invited">Davet Edildi</MenuItem>
                  <MenuItem value="confirmed">Katılacak</MenuItem>
                  <MenuItem value="declined">Katılmayacak</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Notlar"
                multiline
                rows={4}
                value={form.notes}
                onChange={e => handleFormChange('notes', e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={onClose}>İptal</MuiButton>
          <MuiButton type="submit" variant="contained">Ekle</MuiButton>
        </DialogActions>
      </form>
      {/* Taraf Ekleme Diyaloğu */}
      <Dialog open={sideDialogOpen} onClose={() => setSideDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Yeni Taraf Ekle</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Taraf Adı"
            fullWidth
            value={newSide}
            onChange={e => setNewSide(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => setSideDialogOpen(false)}>İptal</MuiButton>
          <MuiButton onClick={() => { onAddSide(newSide); setNewSide(''); setSideDialogOpen(false); }}>Ekle</MuiButton>
        </DialogActions>
      </Dialog>
      {/* Taraf Silme Diyaloğu */}
      <Dialog open={deleteSideDialogOpen} onClose={() => setDeleteSideDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Taraf Sil</DialogTitle>
        <DialogContent>
          <span>Bu tarafı silmek istediğinizden emin misiniz?</span>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => setDeleteSideDialogOpen(false)}>İptal</MuiButton>
          <MuiButton onClick={() => { onDeleteSide(sideToDelete); setDeleteSideDialogOpen(false); }}>Sil</MuiButton>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};
export default AddParticipantModal; 